import styles from "./index.module.scss";

type SentenceParagraphProps = {
  text: string;
  className?: string | undefined;
};

/**
 * 長文を句点「。」の直後で分割し、1文ごとに段落として描画するコンポーネント。
 * LLM 出力の長文を可読性高く見せたいときに使用する。
 */
export const SentenceParagraph = ({ text, className }: SentenceParagraphProps) => {
  const sentences = text
    .split(/(?<=。)/)
    .map((s) => s.trim())
    .filter(Boolean);

  return (
    <div className={className}>
      {sentences.map((sentence, index) => (
        <p key={`${index}-${sentence}`} className={styles["sentence"]}>

          {sentence}
        </p>
      ))}
    </div>
  );
};
